export default __webpack_public_path__ + "static/media/julia.2f794baf.svg";